/** Legacy export names retained for consumers; availability is now standard. */
export function centerPreviewCandidate(rootState) {
    const user = rootState?.user;
    return user?.isLoggedIn === true && !!user?.token;
}

export function centerPreviewEnabled(rootState) {
    return centerPreviewCandidate(rootState);
}
